(() => {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d34"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d34"] = parcelRequire;
}
parcelRequire.register("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = {};
function $f13ecebb1f16f955$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$f13ecebb1f16f955$var$mapping[keys[i]] = pairs[keys[i]];
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRequire.register("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

var $4da9107f33dbf220$exports = {};

(parcelRequire("kI8SP")).register(JSON.parse('{"6ZzK6":"theme.js","bDfcA":"favicon.png","bTX1Z":"theme.css"}'));

/*
 * 
 *  MIT License
 * 
 * © Copyright 2022 Adobe. All rights reserved.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ // Stylesheets

var $42536ebe6eec7230$exports = {};


$42536ebe6eec7230$exports = (parcelRequire("hIarR")).getBundleURL("6ZzK6") + "resources/images/" + (parcelRequire("kI8SP")).resolve("bDfcA");



})();
//# sourceMappingURL=theme.js.map
